import {loadFlightSearchCalendars, loadFullCalendar} from './components/datepicker';
import {loadCustomSelect, initCustomSelectClickHandler} from './components/customselect';
import {initParkingRequest} from "./components/parkingRequest";
import './components/flightSearchRequest';
import './components/smoothscroll';
import './partials/flightsearch';
import './partials/menu';

$(() => {
    loadCustomSelect();
    initCustomSelectClickHandler();
    loadFlightSearchCalendars();
    loadFullCalendar();
    initParkingRequest();
});
